module.exports = __webpack_public_path__ + "static/img/web_landing.6bf81aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/website/web_landing.svg
// module id = j3Ik
// module chunks = 1